<template>

  <el-card class="box-card">
    <div slot="header" class="flex justify-between">
      <span>店铺审核信息</span>
      <div class="float-right">
        <el-button type="primary" @click="goBack">
          返回
        </el-button>
      </div>
    </div>
    <div class="card-body text-left">
      <el-form>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="店铺名称：">
              <span v-if="viewShopAuditInfo.shopName == preShopInfo.shopName || viewShopAuditInfo.state == '002'">
                {{ viewShopAuditInfo.shopName }}
              </span>
              <span v-else>
                {{ preShopInfo.shopName }} 变更为：
                <span style="color: red;">{{ viewShopAuditInfo.shopName }}</span>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺描述：">
              <span v-if="viewShopAuditInfo.shopDesc == preShopInfo.shopDesc || viewShopAuditInfo.state == '002'">
                {{ viewShopAuditInfo.shopDesc }}
              </span>
              <span v-else>
                {{ preShopInfo.shopDesc }} 变更为：
                <span style="color: red;">{{ viewShopAuditInfo.shopDesc }}</span>
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="店铺类型：">
              <span v-if="viewShopAuditInfo.shopType == preShopInfo.shopType || viewShopAuditInfo.state == '002'">
                {{ viewShopAuditInfo.shopTypeName }}
              </span>
              <span v-else>
                {{ preShopInfo.shopTypeName }} 变更为：
                <span style="color: red;">{{ viewShopAuditInfo.shopTypeName }}</span>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开店类型：">
              <span v-if="viewShopAuditInfo.openType == preShopInfo.openType || viewShopAuditInfo.state == '002'">
                {{ openTypeName(viewShopAuditInfo.openType) }}
              </span>
              <span v-else>
                {{ openTypeName(preShopInfo.openType) }} 变更为：
                <span style="color: red;">{{ openTypeName(viewShopAuditInfo.openType) }}</span>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="店铺logo：">
              <div v-if="viewShopAuditInfo.shopLogo == preShopInfo.shopLogo || viewShopAuditInfo.state == '002'">
                <el-image style="width: 60px; height: 60px; border-radius: 5px;" :src="viewShopAuditInfo.shopLogo"
                  fit="cover" />
              </div>
              <div v-else>
                <el-image style="width: 60px; height: 60px; border-radius: 5px;" :src="preShopInfo.shopLogo"
                  fit="cover" />
                变更为：
                <el-image style="width: 60px; height: 60px; border-radius: 5px;" :src="viewShopAuditInfo.shopLogo"
                  fit="cover" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="店铺地址：">
              <span v-if="viewShopAuditInfo.sendAddress == preShopInfo.sendAddress || viewShopAuditInfo.state == '002'">
                {{ viewShopAuditInfo.sendAddress }}
              </span>
              <span v-else>
                {{ viewShopAuditInfo.sendAddress }} 变更为：
                <span style="color: red;">{{ preShopInfo.sendAddress }}</span>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地域编码：">
              {{ viewShopAuditInfo.areaName }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="售后退货地址：">
              {{ viewShopAuditInfo.returnAddress }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="售后联系人：">
              {{ viewShopAuditInfo.returnPerson }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              {{ viewShopAuditInfo.returnLink }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="申请原因：">
              {{ viewShopAuditInfo.applyOpinion }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('shopAudit.businessLicense')">
              <a v-if="viewShopAuditInfo.businessLicense" :href="viewShopAuditInfo.businessLicense" target="_blank">下载/查看</a>
              <span v-else>-</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('shopAudit.foodLicense')">
              <a v-if="viewShopAuditInfo.foodLicense" :href="viewShopAuditInfo.foodLicense" target="_blank">下载/查看</a>
              <span v-else>-</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('shopAudit.idCardFront')">
              <a v-if="viewShopAuditInfo.idCardFront" :href="viewShopAuditInfo.idCardFront" target="_blank">下载/查看</a>
              <span v-else>-</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('shopAudit.idCardBack')">
              <a v-if="viewShopAuditInfo.idCardBack" :href="viewShopAuditInfo.idCardBack" target="_blank">下载/查看</a>
              <span v-else>-</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="viewShopAuditInfo.state == '003'">
          <el-col :span="16">
            <el-form-item label="不通过意见：">
              {{ viewShopAuditInfo.auditOpinion }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>

</template>

<script>
import { queryShop } from '@/api/goods/shopAuditApi'

export default {
  name: 'ViewShopAuditInfo',
  data() {
    return {
      viewShopAuditInfo: {
        auditId: '',
        shopId: '',
        shopLogo: '',
        storeId: '',
        shopName: '',
        shopDesc: '',
        sendAddress: '',
        returnAddress: '',
        shopTypeName: '',
        areaName: '',
        returnPerson: '',
        returnLink: '',
        state: '',
        shopType: '',
        openType: '',
        areaCode: '',
        auditOpinion: '',
        applyOpinion: '',
        businessLicense: '',
        foodLicense: '',
        idCardFront: '',
        idCardBack: ''
      },
      preShopInfo: {
        shopId: '',
        shopName: '',
        shopLogo: '',
        shopType: '',
        openType: '',
        shopDesc: '',
        sendAddress: '',
        storeId: '',
        returnPerson: '',
        returnLink: '',
        returnAddress: '',
        applyOpinion: '',
        state: '',
        areaCode: '',
        businessLicense: '',
        foodLicense: '',
        idCardFront: '',
        idCardBack: ''
      }
    }
  },
  methods: {
    open(data) {
      Object.assign(this.viewShopAuditInfo, data)
      this.getPreShopInfo(data.shopId)
    },
    getPreShopInfo(shopId) {
      queryShop({ shopId, page: 1, row: 1 }).then(res => {
        if (res.data && res.data.length > 0) {
          this.preShopInfo = res.data[0]
        }
      })
    },
    openTypeName(state) {
      if (state == "1") return "商家"
      if (state == "2") return "服务"
      if (state == "3") return "商家和服务"
      return ""
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}

.float-right {
  float: right;
}
</style>